import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutationWithValidation } from 'src/editor/api/hooks/use-api-mutation-with-validation'
import { setWebsitePagesQueryDataArgs } from 'src/editor/api/hooks/use-query-website-pages'
import { deleteWebsitePageRequest } from 'src/editor/api/website-pages-api'
import { WarningDialogWindow } from 'src/editor/shared/ui-lib/modal-window/dialog-window/warning-dialog-window'

export interface DeletePageModalProps {
  websiteId: number
  websitePageSetId: number
  pageName?: string
  isOpened: boolean
  onClose: () => void
}

export const DeletePageModal = ({
  websiteId,
  websitePageSetId,
  pageName,
  isOpened,
  onClose,
}: DeletePageModalProps) => {
  const { t } = useTranslation()

  const { fetcher, isLoading } = useMutationWithValidation({
    requestFunction: deleteWebsitePageRequest,
    successToastMessage: t(
      'website_settings.sidebar.pages_management.delete_page.removed_successfully',
    ),
    handleFinally: onClose,
    setQueryDataArgsOnSuccess: setWebsitePagesQueryDataArgs(
      websiteId,
      prevData => ({
        ...prevData,
        pages: prevData.pages.filter(
          websitePageSet => websitePageSet.id !== websitePageSetId,
        ),
      }),
    ),
  })

  const handleRemovePage = () => {
    fetcher({ websitePageSetId })
  }

  return (
    <WarningDialogWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t('website_settings.sidebar.pages_management.delete_page.title')}
      description={t(
        'website_settings.sidebar.pages_management.delete_page.description',
        { pageName },
      )}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        isLoading,
        onClick: handleRemovePage,
        children: t('components.core.actions.remove'),
      }}
    />
  )
}
